// Vendors
import { useEffect, useState } from 'react';
// Handlers
import { FeatureFlagsHandlers } from '../handlers/feature-flags.handlers';
// Types
import type { FeatureFlagsReturnHookType } from './types/feature-flags-return.hook.type';

const FeatureFlagsHook = (): FeatureFlagsReturnHookType => {
  const [fetching, setFetching] = useState(true);

  const { handleLoadFeatureFlags } = FeatureFlagsHandlers({ setFetching });

  useEffect(() => {
    handleLoadFeatureFlags();
  }, []);

  return { fetching };
};

export default FeatureFlagsHook;
